export default "__VITE_ASSET__BvVBRgQn__"